import authRequest from '@/modules/auth-request.js';
import http from '@/modules/http';
import { couponFromDto } from '@/modules/coupon-dto';

export default {

	getCouponDetails(couponCode) {
		if (typeof couponCode !== 'string' || couponCode === '') {
			return Promise.reject(new Error('Invalid Coupon Code'));
		}


		return authRequest.get('COUPON_API://coupons/' + couponCode)
			.then(http.resolveData)
			.then(data => {
				return couponFromDto(data);
			})
			.catch(http.rejectData);
	}

};



// WEBPACK FOOTER //
// ./src/modules/coupon-api.js